module.exports = __webpack_public_path__ + "media/photo/electric_servic-a7beb5cd.jpg";